var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.warningModal},[_c('p',[_vm._v("确定删除此张人工添加的图片？")])])}
var staticRenderFns = []

export { render, staticRenderFns }